import { ChipProps } from './types'
import { GhostChip } from './variants/GhostChip'
import { OutlinedChip } from './variants/OutlinedChip'
import { SolidChip } from './variants/SolidChip'

export function Chip({ variant, color, ...rest }: ChipProps) {
  switch (variant) {
    case 'solid':
      return <SolidChip color={color} {...rest} />
    case 'outlined':
      return <OutlinedChip color={color} {...rest} />
    case 'ghost':
      return <GhostChip color={color} {...rest} />
  }
}
